import type { CreateObjectAddressDraft } from '../../../lib/address'

import type { CreateObjectAddressFormValues } from './address-step-form'

export const mapAddressFormValuesToDraft = (
  formValues: CreateObjectAddressFormValues,
  savedAddressDraft?: CreateObjectAddressDraft | null,
): CreateObjectAddressDraft => ({
  regionId: formValues.regionId,
  cityId: Number(formValues.cityId),
  street: formValues.street,
  houseNumber: formValues.houseNumber,
  latitude: savedAddressDraft?.latitude ?? null,
  longitude: savedAddressDraft?.longitude ?? null,
})
